

import templatePostItem from '@/app-template/lib/components/PostItem.vue';

export default {
  components: { templatePostItem },
};
